import React from 'react';

import { reportError } from '@kamernet/core/Errors';

function loadScript(src: string, id: string) {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

function addStyles() {
  const css = `
    .react-swipeable-view-container, .flipbase-player-ui, .flipbase-player {
      height: 100% !important;
    }
    .react-swipeable-view-container {
      align-items: center;
    }
  `;

  const { head } = document;
  const style = document.createElement('style');

  head.appendChild(style);
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
}

export const FlipBaseVideoPlayer = ({
  videoId,
  playerId,
}: {
  videoId: string;
  playerId: string;
}) => {
  React.useEffect(() => {
    let player: { mount: () => void; unmount: () => void };

    loadScript(
      'https://cdn.flipbase.com/player/v2/player.min.js',
      'flipbase-player-script',
    )
      .then(() => {
        player = new window.FlipbasePlayer!({
          video_id: videoId,
          player_id: playerId,
          selector: 'video-player-element',
        });

        player.mount();
        addStyles();
      })
      .catch(error => {
        reportError(error as Error, {
          extra: {
            context: 'Failed to load flipbase video player',
            metaData: { error },
          },
        });
      });

    return () => {
      if (player) player.unmount();
    };
  }, [videoId, playerId]);

  return <div id="video-player-element" style={{ height: '100%' }} />;
};
